import React from 'react';
import Admin from '../admin/Admin';

function AdminPage() {
  return <Admin />;
}

export default AdminPage;
